import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import imagen1 from '../images/imagen1.jpg';
import imagen2 from '../images/imagen2.jpg';
import '../styles/Carousel.css';

const MyCarousel: React.FC = () => (
  <div className="full-width-carousel">
    <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
      <div>
        <img src={imagen1} alt="Slide 1" className="slide1" />
      </div>
      <div>
        <img src={imagen2} alt="Slide 2" className="slide2" />
      </div>
    </Carousel>
  </div>
);

export default MyCarousel;
